import { Props } from "./Models";

const HeaderView = ({
    title,
    goBack,
    hasLeftButton,
    rightButton,
}: Props) => {
    return <header className="z-10 w-full bg-white h-[calc(72px)] text-black flex items-center justify-center">
        <div className="relative w-full flex items-center justify-center max-w-[calc(900px)] h-full">
            <h1 className="text-base">{title}</h1>
            {hasLeftButton && <button onClick={goBack} className="absolute left-3">
                <img 
                    src={"/arrow-left.png"}
                    width={24}
                    height={24}
                    alt="voltar"
                />
            </button>}
            {rightButton && <div className="absolute right-3">
                {rightButton}
            </div>}
        </div>
    </header>;
}

export default HeaderView;